import {Route, Routes} from 'react-router-dom';

import {List} from './List';

export default function Token() {

  return (
    <Routes>
      <Route path="/" element={<List/>}/>
    </Routes>
  );
}
